import { z } from "zod";
import { localizedTextSchema, requiredLocalizedTextSchema, timestampsSchema } from "./common";
import { listQueryBaseSchema } from "./list-query";

export const countryDtoSchema = z
  .object({
    id: z.string().uuid(),
    name: localizedTextSchema,
    iso: localizedTextSchema,
    code: localizedTextSchema,
    currency: localizedTextSchema,
  })
  .extend(timestampsSchema.shape);
export type CountryDTO = z.infer<typeof countryDtoSchema>;

export const countryUpsertSchema = z.object({
  name: requiredLocalizedTextSchema,
  iso: requiredLocalizedTextSchema,
  code: requiredLocalizedTextSchema,
  currency: requiredLocalizedTextSchema,
});
export type CountryUpsertInput = z.infer<typeof countryUpsertSchema>;

export const countriesListQuerySchema = listQueryBaseSchema.extend({});
export type CountriesListQuery = z.infer<typeof countriesListQuerySchema>;
